<template>
  <router-view />
</template>

<script>
import { AppMain } from './components'
export default {
  components: {
    AppMain
  },
  data() {
    return {
      
    };
  },
  created() {
    
  },
  methods: {
    
  },
}
</script>
<style scoped>

</style>